import { GRANULARITY } from '../../consts';
import { getTimeRangesByGranularity } from 'views/root/views/home/views/dashboard/util';
import { getGranularityByDates } from '../../custom-report.util';

export const getGranularityAccordingToDatesAndChoice = (
  start_date,
  end_date,
  selectedGranularity = GRANULARITY.AUTO,
  isMetricsV2,
  workingDaysSetting
) => {
  const granularity = getGranularityByDates({
    selectedGranularity,
    end_date,
    start_date
  });
  const rollupDateRanges = getTimeRangesByGranularity(
    start_date,
    end_date,
    granularity,
    isMetricsV2,
    workingDaysSetting
  );
  return { granularity, rollupDateRanges };
};
